import { useQuery } from '@tanstack/react-query'
import React from 'react'

import { type BrandAccount, type RestorePage_MainQuery } from '~/gql/graphql'
import { safeParseJson } from '~/utils'

import { useMainQueryKey } from './useMainQueryKey'

type RestoringParams = {
  brandAccountId: BrandAccount['id']
  replace: {
    path: string
    state: unknown
  }
}

export const useMainQueryData = () => {
  const queryKey = useMainQueryKey()

  const { data } = useQuery<RestorePage_MainQuery>({ enabled: false, queryKey })

  return React.useMemo(
    () => safeParseJson<Unsafe<RestoringParams>>(data?.restoringParams?.value),
    [data?.restoringParams?.value],
  )
}
